function JobItem({ name, date, desc, points, reveal=false, ...rest }) {
    return (
        <div {...rest}>
            <div className='top-info'>
                <h3 className={reveal? 'reveal-on-scroll': ''}> {name} </h3>
                <h3 className={reveal? 'reveal-on-scroll': ''}> {date} </h3>
            </div>
            <p className={reveal? 'reveal-on-scroll': ''}>
                {desc}
            </p>
            <ul className={reveal? 'reveal-on-scroll': ''}>
                {points.map((point, index) => (
                    <li key={index}>
                        <p>{point}</p>
                    </li>
                ))}

            </ul>
        </div>
    )
}


export default JobItem;